import { render, staticRenderFns } from "./splashscreenCardSkeleton.vue?vue&type=template&id=1f4eb1af&"
import script from "./splashscreenCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./splashscreenCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "../style.module.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports